import SettingsPanel from "../components/SettingsPanel/SettingsPanel";

export default function SettingsView() {
  return <SettingsPanel />;
}

